// extracted by mini-css-extract-plugin
export default {"root":"_24JrP","dd":"_2UOJB","hype":"siril"};